import {
  SERVICE_TIMES_GET,
  SERVICE_TIMES_RECEIVE,
  SERVICE_TIME_SELECT,
  SET_SERVICE_TIME_ERRORS
} from '../actionTypes/serviceTimes';


export function getServiceTimes() {
  return (dispatch, getState) => {
    if (!getState().serviceTimes.fetched) {
      dispatch({
        type: SERVICE_TIMES_GET
      });

      fetch('https://planyourvisit.calvary-abq.apps.blackpulp.com/api/v1/service_times')
        .then(response => response.json())
        .then(response => {
          dispatch({
            type: SERVICE_TIMES_RECEIVE,
            serviceTimes: response.data
          });
        });
    }
  };
}


export const setServiceTime = (value) => ({
  type: SERVICE_TIME_SELECT,
  value
});


export const setServiceTimeErrors = (errors) => ({
  type: SET_SERVICE_TIME_ERRORS,
  errors
});


// WEBPACK FOOTER //
// ./src/actions/serviceTimes.js